import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { Router } from '@angular/router';
import { UserStaffDetailDto } from '@cradua/data';
import {  User } from '@cradua/domain';
import Swal from "sweetalert2";
import { GatewayFacade } from './../../../../../gateway/src/lib/states/+gateway/gateway.facades';
import { AuthFacade } from './../../../../../auth/src/lib/facades/auth.facade';

import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';

import { AuthenticationService } from 'apps/epims/mrsoftepims/src/app/services/auth.service';

import { Guid } from "guid-typescript";
import { take } from 'rxjs/operators';
import { Patch } from '@nestjs/common';

@Component({
  selector: 'cradua-staffregister',
  templateUrl: './staffregister.component.html',
  styleUrls: ['./staffregister.component.scss']
})
export class StaffregisterComponent implements OnInit {

  href: string = "";
  staffForm: FormGroup;
  staffinfolist: any;
  staffinfolistMain: any;
  staff = new EventEmitter<UserStaffDetailDto>();
  user: User;
  showDateJoined = true;
  
  constructor(private fb: FormBuilder, private router: Router, private gatewayFacade: GatewayFacade, private authFade: AuthFacade,
    private gatewayService: GatewayService,public authServ: AuthenticationService) {
      this.user = this.authServ.getUser();

      console.log("All Users ",this.user );
     }

  ngOnInit(): void {
    this.staffForm = this.fb.group({
      StaffId: [""],
      LastName: ["", Validators.required],
      FirstName: ["", Validators.required],
      MiddleName: [""],
      PhoneNo: [""],
      EmailAddress: ["", Validators.required],
      StaffName: [""],
      password:[""],
      dateJoined: [""],

      id: null,
      
    });

     const todaysDate = new Date();
    this.staffForm.value.dateJoined = todaysDate;
  this.staffForm.controls['dateJoined'].setValue(todaysDate);

    this.getRegisteredStaffMain();
   this.getRegisteredStaff();

   let location =  window.location.href.split('#')[0];

  this.href = location;
  }
 
  getRegisteredStaff(){
    this.gatewayFacade.loadGateway("IdentityUser").subscribe((staffinfoe) => {
      this.staffinfolist = staffinfoe;
      console.log("User Details ", this.staffinfolist);
    });
   
 }

 getRegisteredStaffMain(){
  this.gatewayFacade.genericFilterGateway("IdentityUser","SubscriberId",this.user.SubscriberId).pipe(take(5)).subscribe((data) => {
    this.staffinfolistMain = data;
    console.log("User Staff gotten ", this.staffinfolistMain, this.user.SubscriberId);
  });
 
}
 
 onSubmit() {

  // Check if Email Exist 

  

  const pullData: UserStaffDetailDto = this.staffForm.value;

  

  pullData.StaffName = this.staffForm.value.LastName + ", " +
  this.staffForm.value.FirstName;

if (this.staffForm.value.id === "" || this.staffForm.value.id === null) {

  let userExist = this.staffinfolistMain.find(j => j['Email'] === pullData.EmailAddress.toLowerCase())

  console.log("Found User ", userExist);
  if(userExist){

    Swal.fire({
      title: 'User exist!',
      text: 'Cross check your entries to proceed',
      type: 'warning',
    
          heightAuto: false,
    })

    return;
  }

  if (
    this.staffForm.value.FirstName === "" ||
    this.staffForm.value.LastName === "" ||
    this.staffForm.value.PhoneNo === "" ||
    this.staffForm.value.EmailAddress === ""
  ) {
    Swal.fire(
      "Please ensure that the compulsory fields are entered",
      "Incomplete Details!",
      "error",
    );
    return;
  }

  this.gatewayService.isLoading$.next(true);
   delete this.staffForm.value.id;

   
   this.staffForm.value.EmailAddress = this.staffForm.value.EmailAddress.toLowerCase();

   console.log("Submitted Data ", this.staffForm.value);
 
  this.gatewayFacade.add("UserStaffDetail", this.staffForm.value);


  let dateExpiringDate = new Date();
  dateExpiringDate.setDate(dateExpiringDate.getDate() + 2);


  // this.userUpdate.resetPasswordExpires = date;
  // this.userUpdate.resetPasswordToken = this.generateRandomString(35);


 
 
  let user = {
    UserName: pullData.EmailAddress.toLowerCase(),
    Email: pullData.EmailAddress.toLowerCase(),
    PhoneNo: pullData.PhoneNo,
    FirstName: pullData.FirstName,
    LastName: pullData.LastName,
    StaffName: pullData.StaffName,
    password: 'welcome',
    UserType: 'Staff',
    SubscriberId: this.user.SubscriberId,
    SiteId: this.user.SiteId,
    SubscriberName: this.user.SubscriberName,
    userRole: 'staff',
    Id:  Guid.create().toString(),
    resetPasswordExpires: dateExpiringDate,
    resetPasswordToken: this.generateRandomString(35)

  };

  let newAdd = [];
  console.log("User Identity", user);
  newAdd.push(user)


   
  let mailData = { fromEmail: '', toEmail: user.Email, subject: 'Manage Account', task:'', responsibility: '',
  pipelinename: '', pipelinerequestdesc: '', period: '', message: '', salutation: '', footer: '', url: ''};

  let salute = "Dear " + user.StaffName + ' ,';

  let conformButtonMsg = "";


  mailData.salutation = salute;

  let linkURL = this.href + '#/auth/manage/' + user.Id + '/' + user.resetPasswordToken;
 
  mailData.message = "Click on the link below to change your access credentials.  " + linkURL ;
  
  mailData.footer = '';
 

 
 mailData.url = linkURL;
 
 console.log("Sending mail ", mailData, user.Id);
  this.gatewayService.sendManageAccountMail(mailData).subscribe((data) => {

 });

 this.staffForm.reset();

  this.authFade.addNewUser(newAdd);

    this.gatewayService.isLoading$.subscribe((data) => {

      if(!data){
        this.getRegisteredStaffMain();
      }
    })
 
 
} else {
  //update here .....

  // console.log("Updated Data ", pullData);
  pullData.StaffName = this.staffForm.value.LastName + ", " +
    this.staffForm.value.FirstName + " " +
    this.staffForm.value.MiddleName;
  //this.gatewayFacade.update("UserStaffDetail");

  let user = {
    UserName: pullData.EmailAddress.toLowerCase(),
    Email: pullData.EmailAddress.toLowerCase(),
    PhoneNo: pullData.PhoneNo,
    FirstName: pullData.FirstName,
    LastName: pullData.LastName,
    StaffName: pullData.StaffName,
  
    SubscriberId: this.user.SubscriberId,
    SiteId: this.user.SiteId,
    SubscriberName: this.user.SubscriberName,
 
    Id:  this.staffForm.value.id,
   

  };

  console.log("Patched Data ", user);

  //return;

   let batchData = [];

  //this.gatewayFacade.update("IdentityUser", [this.staffForm.value],[]);
  batchData.push({type: "IdentityUser", data: [user]});

  this.gatewayFacade.add("BatchData",batchData);

  this.staffForm.reset();


  //this.gatewayFacade.update("IdentityUser",[user],[]);

  //this.authFade.(newAdd);

  // Swal.fire(
  //   "Staff details updated",
  //   "Details Updated!",
  //   "success",
  // );
}
   
 }


 generateRandomString (length, randomString="") {
  randomString += Math.random().toString(20).substr(2, length);
  if (randomString.length > length) return randomString.slice(0, length);
  return this.generateRandomString(length, randomString);
};

patchStaffForm(staff){

  this.staffForm.patchValue(staff);

  this.staffForm.value.EmailAddress = staff['Email'];

 console.log("date Joined ", this.staffForm.value.dateJoined);

 if(this.staffForm.value.dateJoined === null){
   const todaysDate = new Date();
  this.staffForm.value.dateJoined = todaysDate;
  this.staffForm.controls['dateJoined'].setValue(todaysDate);
  this.showDateJoined = true;
 }else{
  this.showDateJoined = false;
 }
  

  this.staffForm.controls['EmailAddress'].setValue(staff['Email']);
}

onClearForm(){
  this.staffForm.reset();
}

}
